

export class GxConstants {

    static readonly PRODUCTS_REF = {
        EXPRESS: 'EXPRESS',
        PASS: 'Pass'
    }

    static readonly FARETYPE_CODES = {
        FARE_PRICE: 'FP',
        INSURANCE: 'IN', // AKA PREMIUM UPGRADE
        PROCESSING_FEE: 'FE',
        FULL_SURCHARGE: 'FS',
        THIRD_PARTY: 'TP',
        TAX_BACK: 'TB'
    }

    static readonly FIELD_TYPE = {
        CHECKBOX: 'checkbox',
        RADIO: 'radio'
    }

    static readonly PAYMENT_METHOD = {
        PAYPAL: 'PayPal',
        TNS: 'TNS',
        LOYALTY: 'Loyalty'
    }

    static readonly TNS_RESPONSE_STATUSES = {
        OK: 'ok',
        TIMEOUT: 'request_timeout',
        VALIDATION_ERROR: 'fields_in_error',
        INVALID_SESSION: 'invalid_session'
    }

    static readonly EVENTS = {
        APPLICATION_ERROR: 'application_error',
        RELOAD_AVAILABILITY: 'reload_availability'
    }

    static readonly EXPRESS_FB_CODES = {
        ZZZ: 'ZZZ',
        OZX: 'OZX'
    }

    static readonly PRODUCT_TYPE = {
        BUSPASS: 'BP',
        EXPRESS: 'EX'
    }

    static readonly REPORTING_GROUP = {
        HOP_ON: 'HOHO',
        SHORT_HOP: 'SHORTHOP',
        KPASS: 'KPASS',
        COMMUTER: 'COMM',
        BUS_PASS: 'BPASS',
        PACKAGE: 'PKGP',
        WHIMIT: 'WHIMIT',
        MICRO: 'MICRO',
        SPECIAL: 'SPECIAL'
    }


    static readonly PASS_CATEGORY_REFERENCES = {
        HOP_ON: 'minitravellerpass',
        SHORT_HOP: 'micropasss',
        KPASS: 'kilometrepass',
        COMMUTER: 'CommuterPass'
    }

    static readonly PAYMENT_CONTEXT = {
        MANAGE: 'manage',
        CONFIRMATION: 'confirmation'
    }

    static readonly ALLOWED_SECTOR_ADDONS = [
        "FACEMASK", "FACEMASKR"
    ]

    static readonly EXPRESS_ADDONS = [
        "FACEMASK", "FACEMASKR"
    ]

    static readonly EXPRESS_ADDONS_FAREBASIS_EXCLUSIONS = [
        "GDP"
    ]

    static readonly COMPANY = 'GA';
    static readonly CURRENCY = 'AUD';
    static readonly MIN_DATE = '1900-01-01T00:00:00';
    static readonly PASS_UPGRADE_PRODUCT_CODE = 'GAUPGRADE';

    static readonly DateFormatDefault = 'YYYY-MM-DD';
    static readonly DateFormatToSendToApi = 'YYYY-MM-DD h:mm:ss A';
    static readonly DateFormatRecievedFromApi = 'D/MM/YYYY h: mm:ss A';
    // see https://regex101.com/r/jW5aRd/1
    // tslint:disable-next-line:max-line-length
    static readonly PHONE_PATTERN = /^(?:\+?(\d*))? ?(?:\((?=.*\)))?(0?[0-9])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;
    static readonly FIRST_LAST_NAME_PATTERN = '^.{2,}$';
    static readonly PASSWORD_PATTERN = '(?=.*[A-Za-z])(?=.*\d).{8,}';
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/gx.constants.ts